import { toCalendarDate, toDate } from "@repo/utils/date";

const BELGIUM_MARKET_BLOCKED_DATES = [
  "18-05",
  "22-05",
  "26-05",
  "27-05",
  "08-06",
  "10-06",
  "17-06",
  "30-06",
  "01-06",
  "04-06",
];
const BELGIUM_COUNTRIES = new Set(["BE", "BELGIUM", "BELGIQUE"]);

type ShouldBlockBelgiumMissionParams = {
  isAdmin: boolean;
  step: number;
  deadline: Date | string | undefined | null;
  countries: Array<string | undefined>;
  blockedDatesRaw?: string;
};

function isBelgiumCountry(country: string | undefined) {
  if (typeof country !== "string") return false;
  return BELGIUM_COUNTRIES.has(country.trim().toUpperCase());
}

function isBlockedDayMonth(deadline: Date | string | undefined | null, blockedDatesRaw?: string) {
  if (deadline == null) return false;

  const targetDate = toDate(deadline);
  if (!targetDate) return false;
  // Day and month of the Paris day, as "dd-MM".
  const [, month, day] = toCalendarDate(targetDate).split("-");

  const blockedDates =
    typeof blockedDatesRaw === "string" && blockedDatesRaw.length > 0
      ? blockedDatesRaw.split(",")
      : BELGIUM_MARKET_BLOCKED_DATES;
  return blockedDates.some((blockedStr) => {
    const [blockedDay, blockedMonth] = blockedStr.trim().split("-");
    return blockedDay?.padStart(2, "0") === day && blockedMonth?.padStart(2, "0") === month;
  });
}

export function shouldBlockBelgiumClientMission({
  isAdmin,
  step,
  deadline,
  countries,
  blockedDatesRaw,
}: ShouldBlockBelgiumMissionParams) {
  if (isAdmin || step !== 1) return false;

  const hasBelgiumAddress = countries.some(isBelgiumCountry);
  if (!hasBelgiumAddress) return false;

  return isBlockedDayMonth(deadline, blockedDatesRaw);
}
